var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIcVolume40Fill = function SvgIcVolume40Fill(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M15.125 4.956c.13.504.182 1.008.232 1.495l.047.442c.18 1.476.18 8.728 0 10.215l-.047.459v.008c-.046.46-.092.936-.224 1.444C14.78 20.221 13.845 21 12.782 21l-.105-.001c-.587 0-1.226-.36-1.588-.675l-3.526-2.941H5.752c-1.398 0-2.421-1.012-2.607-2.579-.214-1.566-.172-4.253 0-5.677.203-1.483 1.274-2.51 2.607-2.51h1.81l3.46-2.898c.418-.363 1.154-.721 1.736-.719 1.043 0 2.016.752 2.367 1.956M19.95 7.818a1 1 0 1 0-1.737.993 6.4 6.4 0 0 1 .001 6.377 1 1 0 0 0 1.735.996 8.4 8.4 0 0 0 0-8.366"
  })));
};
export default SvgIcVolume40Fill;